<gridster class="height100p" [options]="options">
    <gridster-item [item]="item" *ngFor="let item of dashboard">
      TEST
    </gridster-item>
  </gridster>
